"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lagrangeInterpolation = exports.getAllCombinations = void 0;
const bn_js_1 = __importDefault(require("bn.js"));
const elliptic_1 = require("elliptic");
const ec = new elliptic_1.ec('secp256k1');
// const { BN } = require("bn.js");
const getAllCombinations = (s, k) => {
    let set = s;
    if (typeof set === 'number') {
        set = Array.from({ length: set }, (_, i) => i);
    }
    if (k > set.length || k <= 0) {
        return [];
    }
    if (k === set.length) {
        return [set];
    }
    if (k === 1) {
        return set.reduce((acc, cur) => [...acc, [cur]], []);
    }
    const combs = [];
    let tailCombs = [];
    for (let i = 0; i <= set.length - k + 1; i += 1) {
        tailCombs = (0, exports.getAllCombinations)(set.slice(i + 1), k - 1);
        for (let j = 0; j < tailCombs.length; j += 1) {
            combs.push([set[i], ...tailCombs[j]]);
        }
    }
    return combs;
};
exports.getAllCombinations = getAllCombinations;
function lagrangeInterpolation(shares, nodeIndex) {
    if (shares.length !== nodeIndex.length) {
        return null;
    }
    let secret = new bn_js_1.default(0);
    for (let i = 0; i < shares.length; i += 1) {
        let upper = new bn_js_1.default(1);
        let lower = new bn_js_1.default(1);
        for (let j = 0; j < shares.length; j += 1) {
            if (i !== j) {
                upper = upper.mul(nodeIndex[j].neg());
                upper = upper.umod(ec.curve.n);
                let temp = nodeIndex[i].sub(nodeIndex[j]);
                temp = temp.umod(ec.curve.n);
                lower = lower.mul(temp).umod(ec.curve.n);
            }
        }
        let delta = upper.mul(lower.invm(ec.curve.n)).umod(ec.curve.n);
        delta = delta.mul(shares[i]).umod(ec.curve.n);
        secret = secret.add(delta);
    }
    return secret.umod(ec.curve.n);
}
exports.lagrangeInterpolation = lagrangeInterpolation;
